export { getContract } from "./contract"
export { zoomFetchTokenUris } from "./zoom2"
import { toast } from "react-toast";

export const getTokenUri = async (tokenId, tokenUri) => {
  //console.log(tokenUri)
  const metadata = await fetch(tokenUri)// await fetch(`https://toddlerpillars-metadata-server.herokuapp.com/api/metadata/${tokenId % 100}/${tokenId}`)
    .then((res) => res.json())
    .catch((err) => console.error(err));
  if (metadata) {
    if (!metadata.tokenId) {
      metadata.tokenId = tokenId;
    }
    if (!metadata.id) {
      metadata.id = tokenId;
    }
    return metadata;
  } else
    // Fetching metadata fail, return an object anyway
    return {
      tokenId: tokenId,
      id: tokenId
    }
};


export const handleWalletError = (e) => {
  let errorMessage = "";
  if (e.error && e.error.data && e.error.data.message) {
    errorMessage = e.error.data.message
    console.error(errorMessage);
    toast.error(errorMessage);
  } else if (e.error && e.error.message) {
    errorMessage = e.error.message
    console.error(errorMessage);
    toast.error(errorMessage);
  } else if (e.message) {
    errorMessage = e.message
    console.error(errorMessage);
    toast.error(errorMessage);
  }
};

export const mapRanges = (ranges) => {
  const ToInt = Number;
  const numArr = ranges.split(", ");
  const result = numArr.reduce((a, str) => {
    if (!str.includes("-")) {
      a.push(ToInt(str));
      return a;
    }
    const [low, high] = str.split("-");
    for (let i = Number(low); i <= high; i++) {
      a.push(i);
    }
    return a;
  }, []);
  return result;
}
